import AssignReviewFields from '@/views/backstage/structure/review_management/common/AssignReviewFields'

let account_structure = {
    name: '審核代理人',
    type: 'group',
    fields: [].concat(
        AssignReviewFields['deputy_org_name'],
        AssignReviewFields['deputy_user_name'],
    )
}

export default () => {
    return account_structure
}